// The condition type picker: every drawable type in ONE list, ordered by cost code (CSI) — not grouped by how it is
// drawn. Linear / Area / Symbol is a tag on each row, because an estimator thinks "what is this work" (13 21 13.01 wall
// panel, 10 26 00 wall protection), not "is it a line".

export const STYLE_LABELS = Object.freeze({ linear: "Linear", area: "Area", count: "Count" });
export const styleLabel = (t) => STYLE_LABELS[t?.Style] || "Linear";

// "13 21 13.01" -> [13, 21, 13, 1]; no code -> null (sorts after every coded type).
const codeParts = (code) => {
  const nums = String(code ?? "").match(/\d+/g);
  return nums && nums.length ? nums.map(Number) : null;
};

const compareCodes = (a, b) => {
  const pa = codeParts(a), pb = codeParts(b);
  if (!pa && !pb) return 0;
  if (!pa) return 1;
  if (!pb) return -1;
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? -1) - (pb[i] ?? -1);
    if (d) return d;
  }
  return 0;
};

/** A new array of types ordered by cost code, then name. Types with no code come last. */
export const sortByCostCode = (types = []) =>
  [...types].sort((a, b) => compareCodes(a?.CSICode, b?.CSICode) || String(a?.Name ?? "").localeCompare(String(b?.Name ?? ""), undefined, { numeric: true, sensitivity: "base" }));

/** "13 21 13.01 — 2" Wall Panel System" (no code: just the name). */
export const typeOptionLabel = (t) => (t?.CSICode ? `${t.CSICode} — ${t.Name}` : String(t?.Name ?? ""));

/** Types whose name, code or style contains every word typed. An empty query keeps everything. */
export function filterTypes(types = [], query = "") {
  const words = String(query).toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return types;
  return types.filter(t => {
    const hay = `${t.Name ?? ""} ${t.CSICode ?? ""} ${t.CostCodeDescription ?? ""} ${styleLabel(t)} ${t.Style === "count" ? "symbol" : ""}`.toLowerCase();
    return words.every(w => hay.includes(w));
  });
}
